// extracted by mini-css-extract-plugin
export default {"mainTitle":"SearchResult_mainTitle__9USJ-"};